// extracted by mini-css-extract-plugin
module.exports = {"root":"_b80902","link":"_a6654c","noLink":"_39f316"};